"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 12",
    width: "24",
    height: "12"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M4.5,12C3.1,12,2,10.9,2,9.5S3.1,7,4.5,7S7,8.1,7,9.5S5.9,12,4.5,12z M4.5,8C3.7,8,3,8.7,3,9.5 S3.7,11,4.5,11S6,10.3,6,9.5S5.3,8,4.5,8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M23.5,10h-3C20.2,10,20,9.8,20,9.5S20.2,9,20.5,9h3C23.8,9,24,9.2,24,9.5S23.8,10,23.5,10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M18.5,12c-1.4,0-2.5-1.1-2.5-2.5S17.1,7,18.5,7S21,8.1,21,9.5S19.9,12,18.5,12z M18.5,8 C17.7,8,17,8.7,17,9.5s0.7,1.5,1.5,1.5S20,10.3,20,9.5S19.3,8,18.5,8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M16.5,10h-10C6.2,10,6,9.8,6,9.5S6.2,9,6.5,9h10C16.8,9,17,9.2,17,9.5S16.8,10,16.5,10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M22.5,10C22.2,10,22,9.8,22,9.5V6c0-0.6-0.4-1-1-1h-1.5c-0.2,0-0.4-0.1-0.4-0.3L17.2,1H8.3L6.4,4.7 C6.4,4.9,6.2,5,6,5H2C1.4,5,1,5.4,1,6v3h1.5C2.8,9,3,9.2,3,9.5S2.8,10,2.5,10h-2C0.2,10,0,9.8,0,9.5V6c0-1.1,0.9-2,2-2h3.7 l1.9-3.7C7.6,0.1,7.8,0,8,0h9.5c0.2,0,0.4,0.1,0.4,0.3L19.8,4H21c1.1,0,2,0.9,2,2v3.5C23,9.8,22.8,10,22.5,10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M8.5,5C8.4,5,8.3,5,8.3,4.9C8,4.8,7.9,4.5,8.1,4.3l1-2C9.1,2.1,9.3,2,9.5,2h1C10.8,2,11,2.2,11,2.5 S10.8,3,10.5,3H9.8L8.9,4.7C8.9,4.9,8.7,5,8.5,5z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "14",
    cy: "6.2",
    r: "2"
  }));
};

exports["default"] = _default;